import React, { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface HeaderActionsContextValue {
    actions: ReactNode;
    setActions: (actions: ReactNode) => void;
    clearActions: () => void;
}

const HeaderActionsContext = createContext<HeaderActionsContextValue>({
    actions: null,
    setActions: () => undefined,
    clearActions: () => undefined,
});

interface HeaderActionsProviderProps {
    children: ReactNode;
}

export const HeaderActionsProvider: React.FC<HeaderActionsProviderProps> = ({ children }) => {
    const [actions, setActions] = useState<ReactNode>(null);

    const clearActions = useCallback(() => setActions(null), []);

    const value = useMemo(
        () => ({
            actions,
            setActions,
            clearActions,
        }),
        [actions, clearActions]
    );

    return <HeaderActionsContext.Provider value={value}>{children}</HeaderActionsContext.Provider>;
};

export const useHeaderActions = (): HeaderActionsContextValue => useContext(HeaderActionsContext);
